export const data7_1_2 = [{
    name: "Rooms - Commission 客房 - 佣金",
    name_code: 'Rooms_Commission',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Rooms - Complimentary F&B 客房 - 免费餐饮",
    name_code: 'Rooms_Complimentary_F&B',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Rooms - Guest Supplies 客房 - 客用品",
    name_code: 'Rooms_Guest_Supplies',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Food and Beverage - Entertainment 餐饮 - 宴请",
    name_code: 'Food_and_Beverage_Entertainment',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Total Minor Operating 其他总费用",
    name_code: 'Total_Minor_Operating',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Executive Office 行政办",
    name_code: 'Executive_Office',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Sales & Marketing - Advertisement 市场销售 - 广告费",
    name_code: 'Sales_Marketing_Advertisement',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Sales & Marketing - Promotion 市场销售 - 促销费",
    name_code: 'Sales_Marketing_Promotion',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Sales & Marketing - Entertainment 市场销售 - 宴请",
    name_code: 'Sales_Marketing_Entertainment',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Sales & Marketing - Others 市场销售 - 其他 (不含品牌服务费)",
    name_code: 'Sales_Marketing_Others',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Human Resources 人力资源",
    name_code: 'Human_Resources',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Maintenance 工程维护费用",
    name_code: 'Maintenance',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}, {
    name: "Total",
    name_code: 'Total',
    this_Actual: "0",
    last_Actual: "0",
    contrast: "0",
    percent: "0",
    year_this_Actual: "0",
    year_last_Actual: "0",
    year_contrast: "0",
    year_percent: "0",
}];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-7/data.js